import React from 'react';
import { Button } from '../form-controls';
import { _t } from 'core/language';
import { useAuthModal } from 'core/context';

interface Props {
  label?: string;
  className?: string;
  classBtn?: string;
  classLabel?: string;
  handleClick?: () => void;
}

const LoginItem: React.FC<Props> = ({ label,handleClick, className, classBtn, classLabel }) => {
  const { openModal } = useAuthModal();
  const _handleClick = () => {
    if(typeof handleClick === 'function') {
      handleClick?.();
    }else {
      openModal(() => {})
    }
    
  }
  return (
    <div
        className={`
          flex 
          px-4 
          w-full 
          bg-white 
          text-neutral-900 
          mb-2 
          flex-wrap 
          justify-center
          ${className} 
        `}
        role="region"
        aria-label="Login section"
        >
          <div className={`w-full leading-5 text-[14px] mb-[20px] text-center ${classLabel}`}
            dangerouslySetInnerHTML={{
              __html: label ?? _t('auth.LabelItemLogin'),
            }}
          ></div>
          <Button
              primary
              label={_t('auth.LabelLogin')}
              classBtn={`!px-[33px] !py-[9.5px] font-medium ${classBtn}`}
              size="sm"
              onClickBtn={() => _handleClick()} 
            />
        </div>
  );
};

export default LoginItem;